<template>
  <v-container>
    <v-row>
      <v-col cols="12" xs="12">

        <v-card-title primary-title>
        Importar plantas de excel
        </v-card-title>

          <v-toolbar >
            
             <!-- BTN ATRAS -->
              <v-btn
                small
                class="ma-2"
                color="blue lighten-2"
                :to="{name:'catplantas'}"
                dark>
                  <v-icon class="mx-2" small>mdi-reply</v-icon>
              </v-btn>

            <!-- CARGAR ARCHIVO -->
            <Uploadexcel
              class= "ma-2"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"/>
          <v-btn
            v-if= "vercatalogo"
            @click="subirInfo"
            color= "error" dark> Importar Catálogo
          </v-btn>
        </v-toolbar>
      


      <!-- Loader -->
      <div class="text-xs-center">
        <v-dialog
          v-model="dialog"
          hide-overlay
          persistent
          width="500"
          height="300"
        >
          <v-card
            color="primary"
            dark
          >
            <v-card-text >
              Procesando alta masiva de prodcutos.
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>

      
      <v-card elevation="10" >
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="tableData"
            class="elevation-1"
            fixed-header
            height="450"
            hide-default-footer
            loading-text="Cargando..."
            :search="search"
            :items-per-page="longitud"
          >
          </v-data-table>
      </v-card>
      </v-col>
  
    </v-row>
  </v-container>
</template>

<script>
import Uploadexcel from '@/components/Uploadexcel.vue'

export default {
  name: 'UploadExcel',
  components: { Uploadexcel },
  data() {
    return {

      text:'',
      search:'',
      
      vercatalogo:true,
      verprecios: false,

      errores:'',
      disabled:true,
      
      snackbar: false,
      dialog: false,
      loading: false,
      longitud: 100,

      //DATOS2
      tableData: [],
      Datos3:[],

      headers: [
        { text: 'Id'  , value: 'Id' },
        { text: 'Nombre' , value: 'Nombre' },
        { text: 'Puesto' , value: 'Puesto' },
        { text: 'Planta'  , value: 'Planta' },
        { text: 'Área'    , value: 'Area' },
        { text: 'Jefe inmediato'  , value: 'Jefe' },
        { text: 'Correo Jefe'     , value: 'CorreoJefe' },
      ],

    }
  },

  created(){
   
  },


  methods: {
    beforeUpload(file) {
      this.tableData=[]
      const isLt1M = file.size / 1024 / 1024 < 1
      if (isLt1M) {
        return true
      }
      this.$message({
        message: 'Solo subir archivos excel simples',
        type: 'warning'
      })
      return false
    },

    handleSuccess({ results, header }) {

      this.tableData = results
      this.longitud = this.tableData.length

      this.tableHeader = header
      console.log('this.tableData',this.tableData)

      // this.ObtenerValoresExcel(results)
      this.ObtenerValores(results)
    },


    // ObtenerValoresExcel (results){

    //   console.log("results", results)

    // //   // var me = this
    // //   // Función para Estandarizar los datos a nombres de Keys std.
    //   var Datos2  =  results.map(myFunction)
    //   console.log("DATOS2",Datos2)

    //   function myFunction(value) {
    //     return value
    //   }

    //   console.log("Datos2",JSON.stringify(Datos2))
    //   this.tableData= []
    //   this.tableData = Datos2
    //   this.Datos2 = Datos2
    //   console.table(Datos2)
    // },



    ObtenerValores (results){
      this.Datos3=[]
    
      // // RECORRER Results y crear arreglo limpio.
      results.forEach(element =>{
        this.Datos3.push(element)
      })

      // console.log("datos3,", this.Datos3)

    },

    subirInfo(){
      let payload = {
        importarusr: this.Datos3
      }

      console.log(payload)
        
      this.$http.post('auth/api/v1/update.masiva.usuarios', payload).then(response => {
        console.log(response.data)
        this.snackbar= true
        this.text= "Se ha completado con exito."
        
      }).catch(err=>{console.log(err)} )

    },
  
  }
}
</script>